import { Box, Avatar } from '@mui/material';
import { LinkAlt } from '../../../icons/link-alt';

type AvatarWithIndicationProps = {
  src: string,
  alt: string,
};

const style = {
  mainBox: {
    height: '56px',
    width: '56px',
  },
  icon: {
    color: 'white',
    width: '16.67px',
  },
  iconBox: {
    height: '28px',
    width: '28px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    bottom: '28px',
    left: '42px',
    border: '2px solid white',
    sx: {
      backgroundColor: 'primary.main',
    },
  },
  imgProps: {
    style: {
      objectFit: 'contain',
    },
  },
} as const;

export const AvatarWithIndication = ({
  alt,
  src,
}:AvatarWithIndicationProps): JSX.Element => {
  return (
    <Box>
      <Avatar
        style={ style.mainBox }
        imgProps={ style.imgProps }
        alt={ alt }
        src={ src }
      />
      <Box style={ style.iconBox } sx={ style.iconBox.sx }>
        <LinkAlt style={ style.icon } />
      </Box>
    </Box>
  );
};
